import type { GameProfileSearchResults } from "@/data-models/search-players.mjs";
import type { GameSearchProps, SearchResult } from "@/search/types.mjs";
import { proxy } from "@/util/proxy.mjs";

const searchRefs = proxy({
  hookSearchResults(
    _name: GameSearchProps,
    results: GameProfileSearchResults,
  ): GameProfileSearchResults | Promise<GameProfileSearchResults> {
    return results;
  },
  shouldShowGlobalSearch: false,
  globalSearchQuery: "",
  globalSearchInputAttrs: null,
  trackSearchOpen: () => {},
  trackSearchClose: () => {},
  trackSearchResultClick: (
    _result: SearchResult,
    _fromRecentSearches: boolean = false,
  ) => {},
});

export default searchRefs;
